export const VIEW_MODE_SET = 'at/taskManagement/VIEW_MODE_SET'
export const SINGLE_CP_SELECTION_CHANGE = 'at/taskManagement/SINGLE_CP_SELECTION_CHANGE'
export const FILTER_CP_SELECTION_CHANGE = 'at/taskManagement/FILTER_CP_SELECTION_CHANGE'
export const CP_NAME_FILTER_SET = 'at/taskManagement/CP_NAME_FILTER_SET'
export const TASK_STATUS_FILTER_CHANGE = 'at/taskManagement/TASK_STATUS_FILTER_CHANGE'
export const CUSTOM_FIELDS_FILTERS_SET = 'at/taskManagement/CUSTOM_FIELDS_FILTERS_SET'
export const SELECTED_FILTER_KEYS_SET = 'at/taskManagement/SELECTED_FILTER_KEYS_SET'
export const TASK_NAME_FILTER_CHANGE = 'at/taskManagement/TASK_NAME_FILTER_CHANGE'
export const LAST_CREATED_TASK_IDS_SET = 'at/taskManagement/LAST_CREATED_TASK_IDS_SET'
export const LAST_CREATED_TASK_IDS_REMOVE = 'at/taskManagement/LAST_CREATED_TASK_IDS_REMOVE'
export const NEXT_WORKFLOW_STATUSES_SET = 'at/taskManagement/NEXT_WORKFLOW_STATUSES_SET'
export const RECENTLY_CREATED_TASKS_ADD = 'at/taskManagement/RECENTLY_CREATED_TASKS_ADD'
export const RECENTLY_CREATED_CUSTOMER_IDS_SET = 'at/taskManagement/RECENTLY_CREATED_CUSTOMER_IDS_SET'
export const RECENTLY_CREATED_PROJECT_IDS_SET = 'at/taskManagement/RECENTLY_CREATED_PROJECT_IDS_SET'
export const RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR = 'at/taskManagement/RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR'
export const MANAGEMENT_ASSIGNMENTS_SET = 'at/taskManagement/MANAGEMENT_ASSIGNMENTS_SET'
export const VIEWER_SETTINGS_SET = 'at/taskManagement/VIEWER_SETTINGS_SET'
export const HAS_MANAGEABLE_TASKS_SET = 'at/taskManagement/HAS_MANAGEABLE_TASKS_SET'
export const SHOW_ONLY_MANAGEABLE_TASKS_SET = 'at/taskManagement/SHOW_ONLY_MANAGEABLE_TASKS_SET'
export const CP_PANEL_CLOSED_STATE_CHANGE = 'at/taskManagement/CP_PANEL_CLOSED_STATE_CHANGE'
// TODO this action only set read only property when bulk op dialog closed (after animation). Need for refresh scroll.
export const BULK_OPERATIONS_PANEL_SHOWN_SET = 'at/taskManagement/BULK_OPERATIONS_PANEL_SHOWN_SET'
export const TOGGLE_LOADING_MOIRE = 'at/taskManagement/TOGGLE_LOADING_MOIRE'

export const TASK_CUSTOM_FIELDS_SET = 'at/taskManagement/TASK_CUSTOM_FIELDS_SET'



// WEBPACK FOOTER //
// ./web/js/taskManagement/common/actionTypes.js